import React from 'react';

const iconStyle = { flexShrink: 0, marginRight: 6 };

export function FolderClosed(props: { width?: number; height?: number }) {
    const w = props.width ?? 14;
    const h = props.height ?? 12;
    return (
        <svg width={w} height={h} viewBox="0 0 14 12" fill="none" style={iconStyle}>
            <path d="M0 1a1 1 0 011-1h4l2 2h6a1 1 0 011 1v7a1 1 0 01-1 1H1a1 1 0 01-1-1V1z" fill="#8B7355" stroke="#5D4E37" strokeWidth="0.8" />
        </svg>
    );
}

export function FolderOpen(props: { width?: number; height?: number }) {
    const w = props.width ?? 14;
    const h = props.height ?? 12;
    return (
        <svg width={w} height={h} viewBox="0 0 14 12" fill="none" style={iconStyle}>
            <path d="M0 1v10h14V3H7L5 1H0zm2 2h10v6H2V3z" fill="#8B7355" stroke="#5D4E37" strokeWidth="0.6" fillRule="evenodd" />
        </svg>
    );
}

export function FileTs() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#2f74c0" stroke="#1e5a9e" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#1e5a9e" strokeWidth="0.8" fill="none" />
            <text x="6" y="10" fontSize="6" fill="#fff" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">TS</text>
        </svg>
    );
}

export function FileTsx() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#2f74c0" stroke="#1e5a9e" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#1e5a9e" strokeWidth="0.8" fill="none" />
            <text x="6" y="9" fontSize="5" fill="#fff" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">TSX</text>
        </svg>
    );
}

export function FileHtml() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#e44d26" stroke="#c53d1a" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#c53d1a" strokeWidth="0.8" fill="none" />
            <text x="6" y="10" fontSize="5" fill="#fff" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">HTML</text>
        </svg>
    );
}

export function FileCss() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#264de4" stroke="#1a3bb5" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#1a3bb5" strokeWidth="0.8" fill="none" />
            <text x="6" y="10" fontSize="5" fill="#fff" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">CSS</text>
        </svg>
    );
}

export function FileJson() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#cbcb41" stroke="#a3a32e" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#a3a32e" strokeWidth="0.8" fill="none" />
            <text x="6" y="10" fontSize="5" fill="#1e1e1e" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">JSON</text>
        </svg>
    );
}

export function FileGlsl() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#7d4e8c" stroke="#5c3570" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#5c3570" strokeWidth="0.8" fill="none" />
            <text x="6" y="10" fontSize="4" fill="#fff" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">GLSL</text>
        </svg>
    );
}

export function FileGeneric() {
    return (
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" style={iconStyle}>
            <path d="M1 0a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4L8 0H1z" fill="#2D2D2D" stroke="#555" strokeWidth="0.8" />
            <path d="M8 0v4h4" stroke="#555" strokeWidth="0.8" fill="none" />
        </svg>
    );
}

export function getFileIcon(name: string) {
    const ext = name.includes('.') ? name.split('.').pop()?.toLowerCase() : '';
    switch (ext) {
        case 'ts': return FileTs;
        case 'tsx': return FileTsx;
        case 'html': return FileHtml;
        case 'css':
        case 'scss': return FileCss;
        case 'json': return FileJson;
        case 'glsl':
        case 'vert':
        case 'frag': return FileGlsl;
        default: return FileGeneric;
    }
}
